<template>
    <div class="new-live-metrics" style="overflow-x: hidden">

        <div class="d-flex pt-3 pb-5" style="align-items: center; display: flex;">
            <span class="page-label pt-2 ml-3" style="align-items: center; display: flex;"> {{
                $t('message.pages.live.metrics.liveHealth') }}</span>
            <span v-if="liveStatus === 'offline'"
                style="margin-left: auto; border-radius: 30px; padding: 2px 8px 2px 8px; background-color: #c2c6e7; color: white;"
                class="mr-2"> {{
                    $t('message.pages.live.metrics.waiting') }}
            </span>
            <span v-if="liveStatus === 'online' && actualBytesIn > 2500"
                style="margin-left: auto; border-radius: 30px; padding: 2px 8px 2px 8px; background-color: #4CAF50; color: white;"
                class="mr-2"> {{
                    $t('message.pages.live.metrics.good') }}
            </span>
            <span v-if="liveStatus === 'online' && actualBytesIn > 2000 && actualBytesIn < 2499"
                style="margin-left: auto; border-radius: 30px; padding: 2px 8px 2px 8px; background-color: orange; color: white;"
                class="mr-2"> {{
                    $t('message.pages.live.metrics.medium') }}
            </span>
            <span v-if="liveStatus === 'online' && actualBytesIn < 2000"
                style="margin-left: auto; border-radius: 30px; padding: 2px 8px 2px 8px; background-color: red; color: white;"
                class="mr-2"> {{
                    $t('message.pages.live.metrics.bad') }}
            </span>
            <span v-if="liveStatus === 'finished'"
                style="margin-left: auto; border-radius: 30px; padding: 2px 8px 2px 8px; background-color: #c2c6e70; color: white;"
                class="mr-2"> {{
                    $t('message.pages.live.metrics.finished') }}
            </span>
        </div>

        <h2 class="page-label ml-3">Bitrate</h2>
        <v-skeleton-loader v-if="isLoading" width="100%" height="100%" type="image" />

        <apexchart v-if="!isLoading" :class="{ darkThemeSvgFix: $vuetify.theme.dark }" ref="chart" type="area" height="200"
            :options="chartOptions" :series="series"></apexchart>

        <div v-if="!isLoading" class="d-flex mt-4">
            <div class="d-flex flex-column mr-14 ml-5">

                <span class="values" style="color: var(--v-neutral-base);">{{
                    $t('message.pages.live.metrics.currentBitrate') }}</span>
                <span v-if="liveStatus === 'offline' || liveStatus === 'finished'" class="actual-value"> - </span>
                <span v-else class="actual-value"> {{ actualBytesIn }} kbps </span>
            </div>

            <div class="d-flex flex-column">

                <span class="values" style="color: var(--v-neutral-base);">{{
                    $t('message.pages.live.metrics.averageBitrate') }}</span>
                <span v-if="liveStatus === 'offline'" class="average-value"> - </span>
                <span v-else class="average-value">{{ averageBytesIn }} kbps</span>
            </div>
        </div>
    </div>
</template>
  
<script>
import VueApexCharts from 'vue-apexcharts'
import liveService from '@/services/liveServiceV2'


export default {
    name: 'NewLiveV2Metrics',
    components: {
        apexchart: VueApexCharts
    },
    data() {
        return {
            liveTime: ['00:00:00'],
            time: 0,
            liveStatus: 'offline',
            bytesInData: [],
            timestampLive: [],
            isLoading: true,
            timestampStarted: 0,
            timestampReturned: 0,
            averageBytesIn: 0,
            actualBytesIn: 0,
            liveBytesIn: 0,
            previousBytes: 0,
            previousTime: 0,
            liveKbps: 0,
            chartOptions: {
                chart: {
                    id: 'area-chart',
                    type: 'area',
                    toolbar: {
                        show: false
                    }
                },
                colors: ['#3F55EE'],
                fill: {
                    type: 'gradient',
                    gradient: {
                        shadeIntensity: 1,
                        opacityFrom: 0.7,
                        opacityTo: 0.7,
                        stops: [0, 85, 100]
                    }
                },
                dataLabels: {
                    enabled: false
                },
                stroke: {
                    curve: 'smooth',
                    width: 2
                },

                xaxis: {
                    categories: [],
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false
                    },
                    labels: {
                        show: false
                    }
                },
                yaxis: {
                    tickAmount: 3,
                    min: 0,
                    max: 6000,
                    tickPositions: [0, 2000, 4000, 6000],
                    labels: {
                        formatter: function (value) {
                            return value
                        }
                    }
                },
                tooltip: {
                    theme: 'dark',
                },
            },
            series: [{
                name: 'Bitrate',
                data: []
            },]
        }
    },
    mounted() {
        this.$vuetify.theme.dark
            ? (this.chartOptions.tooltip.theme = 'dark')
            : (this.chartOptions.tooltip.theme = 'light')
        this.startMetricsUpdate()
        this.getMetrics()
    },
    beforeDestroy() {
        this.stopMetricsUpdate()
    },
    methods: {

        async updateMetrics() {
    if (this.liveStatus === 'offline') {
        const response = await liveService.getLive(this.$route.params.id)
        this.liveStatus = response.data.status
    }
    if (this.liveStatus === 'online') {
        const metrics = await liveService.getInfoHost(this.$route.params.id)
        
        if (Object.keys(metrics.data.ret).length === 0) {
            return
        }

        this.liveBytesIn = metrics.data.ret.bytes_in
        this.time = metrics.data.ret.time
        this.liveTime.push(this.totalTimeToUpdate(this.time))
        this.addValue(this.calculateKbps({
            bytes_in: this.liveBytesIn,
            time: this.time
        }))
        this.actualBytesIn = this.liveKbps
        const sum = this.series[0].data.reduce((a, b) => a + b, 0)
        this.averageBytesIn = parseInt(sum / this.series[0].data.length, 10)
    }
},
        startMetricsUpdate() {
            this.updateInterval = setInterval(this.updateMetrics, 4000)
        },
        stopMetricsUpdate() {
            clearInterval(this.updateInterval)
        },

        totalTime(timestamp, timestampstart) {
            const diff = timestamp - timestampstart
            const seconds = Math.floor(diff / 1000)
            const hours = Math.floor(seconds / 3600)
            const minutes = Math.floor((seconds % 3600) / 60)
            const secondsRestantes = seconds % 60
            const formattedHours = hours < 10 ? `0${hours}` : `${hours}`
            const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
            const formattedSeconds = secondsRestantes < 10 ? `0${secondsRestantes}` : `${secondsRestantes}`
            return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
        },


        totalTimeToUpdate(time) {
            const seconds = Math.floor(time / 1000)
            const hours = Math.floor(seconds / 3600)
            const minutes = Math.floor((seconds % 3600) / 60)
            const secondsRestantes = seconds % 60
            const formattedHours = hours < 10 ? `0${hours}` : `${hours}`
            const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
            const formattedSeconds = secondsRestantes < 10 ? `0${secondsRestantes}` : `${secondsRestantes}`
            return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
        },


        async getMetrics() {
            try {
                this.isLoading = true
                await this.getLive()
                const metrics = await liveService.getAnalytics(this.$route.params.id)


                if (metrics && metrics.data && Array.isArray(metrics.data) && metrics.data.length > 0) {
                    metrics.data.forEach(metric => {
                        if (metric.bytes_in !== null && metric.bytes_in !== '' && metric.bytes_in !== 'null') {
                            this.bytesInData.push(parseInt(metric.bytes_in))
                            this.timestampLive.push(metric.timestamp)
                            this.liveTime.push(this.totalTime(metric.timestamp, this.timestampStarted))
                        }
                    })
                }
                else {
                    this.bytesInData = [0]
                }
                this.liveTime.reverse()
                this.chartOptions.xaxis.categories = this.liveTime
                this.bytesInData.reverse()
                this.timestampLive.reverse()
                const differenceArray = this.timestampLive.map(timestamp => timestamp - this.timestampStarted)
                const kbpsArray = this.bytesInData.map((bytes, index) => {
                    if (index === 0) return 0
                    return this.calculateKbps({
                        bytes_in: bytes,
                        time: differenceArray[index]
                    })
                })
                const sum = kbpsArray.reduce((a, b) => a + b, 0)
                this.averageBytesIn = parseInt(sum / kbpsArray.length, 10)

                this.series[0].data = kbpsArray
                this.$refs.chart.updateSeries(this.series)
                this.$refs.chart.updateOptions({
                    xaxis: this.chartOptions.xaxis
                })
                this.startMetricsUpdate()
            } 
            finally {
                this.isLoading = false
            }

        },

        calculateKbps({ bytes_in, time }) {
            let kbps = null

            if (this.previousTime === null) {
                this.previousBytes = bytes_in
                this.previousTime = time
            } else {
                const deltaBytes = bytes_in - this.previousBytes
                const deltaTime = (time - this.previousTime) / 1000
                const deltaBits = deltaBytes * 8

                kbps = parseInt(deltaBits / deltaTime / 1000, 10)
            }

            this.previousBytes = bytes_in
            this.previousTime = time

            this.liveKbps = kbps
            return kbps
        },

        async getLive() {
            const response = await liveService.getLive(this.$route.params.id)
            const dataString = response.data.started_at
            this.timestampStarted = Date.parse(dataString)
            this.liveStatus = response.data.status

        },

        async getInfo() {
            await liveService.getInfoHost(this.$route.params.id)
        },

        async addValue(value) {
            this.series[0].data.push(value)
            this.$refs.chart.updateSeries(this.series)
        }
    },
}
</script>
  
<style lang="scss" scoped>
.actual-value {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    color: var(--v-brand-base);
}

.average-value {
    font-size: 20px;
    font-weight: 400;
    line-height: 24px;
    color: var(--v-neutral-lighten1);
}

.new-live-metrics {
    font-size: 0.875rem;
    color: var(--v-neutral-lighten1);
}

.bg-dark {
    .new-live-metrics {
        background-color: var(--v-neutral-darken2);
        color: white;
    }

    .values {
        color: var(--v-primary-base) !important
    }

    .tspan {
        color: white !important;
    }

    .page-label {
        color: var(--v-primary-base) !important
    }

    .page-title {
        color: var(--v-primary-base) !important
    }
}
</style>
  